/* eslint-disable no-shadow */
const state = {
  on_ship_list: [
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
      ship_other_pro: [{
        name: '',
      },
      ],
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
    {
      ship_isShip: false,
      ship_title: '絕對考上導遊＋領隊 有聲書（九版）',
      ship_count: 1,
      ship_status: 'finish',
      ship_moehod: 'post_office',
      ship_price: 80,
      ship_other_unship: 0,
      ship_purchaser: '某A',
      ship_phone: '0987654321',
      ship_remark: '已通知',
      ship_order_date: '2020-04-06',
      ship_date: '',
      ship_uid: 'M19061400010B8',
    },
  ],
  order_ship_list: [{
    pro_id: 0,
    pro_isship: false,
    pro_status: 'pre_order',
    pro_name: '絕對考上＋領隊 有聲書（九版）',
    pro_count: 2,
    pro_ship_method: 'post_office',
    pro_ship_method2: 'payment',
    pro_ship_date: 'none',
    pro_receiver: '會員A',
  },
  {
    pro_id: 1,
    pro_isship: false,
    pro_status: 'pre_order',
    pro_name: '［日＋華］絕對考上 四科套書（九版）',
    pro_count: 2,
    pro_ship_method: 'post_office',
    pro_ship_method2: 'payment',
    pro_ship_date: 'none',
    pro_receiver: '會員A',
  },
  {
    pro_id: 2,
    pro_isship: false,
    pro_status: 'enough_inventory',
    pro_name: '導遊工具書',
    pro_count: 4,
    pro_ship_method: 'on_site',
    pro_ship_method2: 'on_site',
    pro_ship_date: '2020-04-08',
    pro_receiver: '會員A',
  },
  ],
  pro_track_list: [
    {
      pro_track_index: 0,
      pro_track_from: '7-11',
      pro_track_id: 'K7124588',
      pro_track_date: '2020-08-08',
      pro_track_count: 2,
      pro_track_receiver: 'BBB',
      pro_track_address: '235 新北市中和區7-11中和門市',
      pro_track_info: [
        {
          name: '絕對考上導遊＋領隊 有聲書（九版）',
          count: 2,
        },
      ],
    },
    {
      pro_track_index: 1,
      pro_track_from: 'post_office',
      pro_track_id: '0106111044778',
      pro_track_date: '2020-08-08',
      pro_track_count: 2,
      pro_track_receiver: 'BBB',
      pro_track_address: '106台北市大安區OO郵局第OO號信箱',
      pro_track_info: [
        {
          name: '絕對考上導遊＋領隊 有聲書（九版）',
          count: 2,
        },
      ],
    },
    {
      pro_track_index: 2,
      pro_track_from: 'on_site',
      pro_track_id: '會員A',
      pro_track_date: '2020-04-08',
      pro_track_count: 2,
      pro_track_receiver: '會員A',
      pro_track_address: '會員A地址',
      pro_track_info: [
        {
          name: '絕對考上導遊＋領隊 有聲書（九版）',
          count: 2,
        },
      ],
    },
  ],

  selected_ship: [],
};

const actions = {

};

const mutations = {
  changeSelected(state, data) {
    state.selected_ship = data;
  },
  changeIsship(state, data) {
    state.order_ship_list[data].pro_isship = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
